import { BPAFormSchema } from "../../schemas/forms";
import { businessPracticeAreas } from "../../api/bpas.service";
import type { BPA } from "../../api/bpas.service";
import type { HierarchyManagerConfig } from "../../components/HierarchyManager";
import type { ZodType } from "zod";

export const bpaConfig: HierarchyManagerConfig<BPA> = {
  // Display configuration
  title: "Business Practice Areas",
  singularName: "Business Practice Area",
  pluralName: "Business Practice Areas",

  // API service
  apiService: businessPracticeAreas,

  // Form fields configuration (camelCase to match UI/validation)
  formFields: [
    {
      name: "parentId",
      label: "Parent BPA",
      type: "select",
      required: false,
      searchable: true,
      defaultValue: null,
    },
    {
      name: "name",
      label: "Name",
      type: "text",
      required: true,
      placeholder: "Enter BPA name",
      defaultValue: "",
    },
    {
      name: "code",
      label: "Code",
      type: "text",
      required: true,
      placeholder: "Enter BPA code (e.g., CORP-LAW)",
      defaultValue: "",
    },
    {
      name: "slug",
      label: "Slug",
      type: "text",
      required: true,
      placeholder: "Enter BPA slug (e.g., corp-law)",
      defaultValue: "",
    },
    {
      name: "displayOrder",
      label: "Display Order",
      type: "number",
      required: false,
      defaultValue: 0,
      helperText: "Lower numbers appear first",
    },
  ],

  // Validation schema from shared package (camelCase)
  validationSchema: BPAFormSchema,

  // Feature flags
  enableDragAndDrop: true,
  enableSearch: true,
  enableBreadcrumbs: true,
  showCode: true,
  showSlug: true,

  parentOptionLabel: (item: BPA) => {
    const tier = /^l500r-t(\d+)-/.exec(item.code)?.[1];
    return tier ? `${item.name} (T${tier})` : item.name;
  },
};
